"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerScript = void 0;
const default_1 = require("../default");
const Interfaces = __importStar(require("../Interfaces"));
const User_1 = require("./User");
const _BaseParseObject_1 = require("./_BaseParseObject");
const local_parse_1 = require("../local-parse");
const config_1 = require("../config");
class CustomerScript extends _BaseParseObject_1.BaseParseObject {
  get url() {
    return `https://ausscripts.erx.com.au/scripts/${this.code}`;
  }
  static configScraper(url, token) {
    CustomerScript.scraperUrl = url;
    CustomerScript.scraperToken = token;
  }
  static async getScrape(code) {
    const url = CustomerScript.scraperUrl;
    const apiToken = CustomerScript.scraperToken;
    if (!url || !apiToken) throw new Error("Erx not configured!");
    const response = await fetch(CustomerScript.scraperUrl + code, {
      headers: {
        Authorization: apiToken
      }
    });
    const data = (await response.json()).result;
    if (data.prescriptionDate) data.prescriptionDate = new Date(data.prescriptionDate);
    return data;
  }
  static async fetchErxDetails(code, ignoreError = false) {
    const scrape = await CustomerScript.getScrape(code);
    if (scrape.status != "Valid" && !ignoreError) {
      switch (scrape.status) {
        case "Dispensed":
          throw new Error(`This medication has already been dispensed`);
        case "Expired":
          throw new Error(`This prescription has expired`);
        case "Disabled":
          throw new Error(`This prescription has been disabled`);
        case "Cancelled":
          throw new Error(`This prescription has been cancelled`);
      }
    }
    return scrape;
  }
  constructor(attributes) {
    super("CustomerScript", attributes);
  }
  static async getByCode(code) {
    return await CustomerScript.Query().equalTo("code", code).first({
      useMasterKey: config_1.C2UConfig.useMasterKey
    });
  }
  static async create(code, data, user = default_1.ParseUser.current()) {
    if (!user) {
      throw new Error("Cannot create a script without a user!");
    }
    const userPointer = User_1.User.pointer(user.id);
    if (!data) data = await CustomerScript.fetchErxDetails(code);
    const script = new CustomerScript(Object.assign({
      customer: userPointer
    }, data));
    const acl = CustomerScript.createACL();
    script.setACL(acl);
    return await script.save();
  }
  async syncToken() {
    const updatedScrape = await CustomerScript.fetchErxDetails(this.code, true);
    this.electronPrescriptionFor = updatedScrape.electronPrescriptionFor;
    this.medicationName = updatedScrape.medicationName;
    if (updatedScrape.prescriptionDate) this.prescriptionDate = updatedScrape.prescriptionDate;
    this.supplyRemaining = updatedScrape.supplyRemaining || 0;
    this.status = updatedScrape.status;
    return await this.save(undefined, {
      useMasterKey: config_1.C2UConfig.useMasterKey
    });
  }
  static createACL() {
    const acl = new default_1.ParseACL();
    acl.setRoleWriteAccess(default_1.ERoles.Admin, true);
    acl.setRoleWriteAccess(default_1.ERoles.Admin, true);
    const user = default_1.ParseUser.current();
    if (user) {
      acl.setReadAccess(user, true);
      acl.setWriteAccess(user, true);
    }
    return acl;
  }
}
exports.CustomerScript = CustomerScript;
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Object)], CustomerScript.prototype, "customer", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", String)], CustomerScript.prototype, "code", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", String)], CustomerScript.prototype, "medicationName", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", String)], CustomerScript.prototype, "electronPrescriptionFor", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Date)], CustomerScript.prototype, "prescriptionDate", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Number)], CustomerScript.prototype, "supplyRemaining", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", String)], CustomerScript.prototype, "status", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Object)], CustomerScript.prototype, "electronicPrescriptionForFullName", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Object)], CustomerScript.prototype, "isElectronic", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Object)], CustomerScript.prototype, "isChartBased", void 0);
__decorate([(0, _BaseParseObject_1.Accessor)(), __metadata("design:type", Object)], CustomerScript.prototype, "data", void 0);
local_parse_1.Parse.Object.registerSubclass("CustomerScript", CustomerScript);
